import { render, staticRenderFns } from "./block.vue?vue&type=template&id=602f9e08"
var script = {}
import style0 from "./block.vue?vue&type=style&index=0&id=602f9e08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports